/*  ========================================================================
    # Scripts - Header Menu Mobile
    ========================================================================  */

const HeaderMenuMobile = {
  cfg: {
    burger: {
      element: document.querySelector('.c-header__burger'),
      activeClass: 'c-header__burger--active'
    },
    menu: {
      element: document.querySelector('.c-header-menu-mobile'),
      activeClass: 'c-header-menu-mobile--active',
      backdrop: document.querySelector('.c-header-menu-mobile__backdrop'),
      entries: document.querySelectorAll('.c-header-menu-mobile__entry'),
      entryActiveClass: 'c-header-menu-mobile__entry--active',
      submenuButtonClass: 'c-header-menu-mobile__submenu-button'
    }
  },

  /**
   * Show/hide the mobile menu.
   */
  handlerShowHide() {
    window.scrollTo({
      top: 0,
      behavior: 'smooth'
    });

    if (document.body.style.overflow === 'hidden') {
      document.body.style.overflow = '';
    } else {
      document.body.style.overflow = 'hidden';
    }

    this.cfg.burger.element.classList.toggle(this.cfg.burger.activeClass);
    this.cfg.menu.element.classList.toggle(this.cfg.menu.activeClass);
  },

  /**
   * Show/hide the submenus.
   *
   * @param {object} entryObject
   */
  handlerSubmenus(entryObject) {
    if (entryObject.submenuButton) {
      entryObject.submenuButton.addEventListener('click', () => {
        entryObject.entry.classList.toggle(this.cfg.menu.entryActiveClass);
      });
    }
  },

  /**
   * Creates an object for each menu entry.
   */
  entries() {
    this.cfg.menu.entries.forEach(entry => {
      const entryObject = {
        entry,
        submenuButton: entry.querySelector(`.${this.cfg.menu.submenuButtonClass}`) || false
      };

      this.handlerSubmenus(entryObject);
    });
  },

  /**
   * Initialize.
   */
  init() {
    if (this.cfg.burger.element && this.cfg.menu.element) {
      this.cfg.burger.element.addEventListener('click', () => this.handlerShowHide());
      this.cfg.menu.backdrop.addEventListener('click', () => this.handlerShowHide());
      this.entries();
    }
  }
};

export default HeaderMenuMobile;
